export default function IntentDescription() {
    return (
        <div className="row mt-4">
            <p className="mb-2">
                Data sent with this service is end-to-end encrypted and transferred in realtime between
                browsers. No file data, plaintext or encrypted, ever touches the server.
            </p>
        </div>
    )
}